import Grid2 from '@mui/material/Unstable_Grid2/Grid2';
import { concat, get } from 'lodash';
import React, { FC, useMemo } from 'react';
import CreateForm from 'src/components/ui-component/form-component/create-form/CreateForm';
import { useApplication } from 'src/context/ApplicationContext';
import { PLATZHALTER_TEXT } from 'src/lib/constants/constant';
import { FormStrucItem } from 'src/lib/types/types';
import PruefAssistenz from 'src/pages/private/online-antrag/antrag-components/PruefAssistenz';
import {
	checkIfPruefAssitenzNeedsToValidate,
	getProjektLaufzeitBIS_Validation,
	getProjektLaufzeitVON_Validation,
} from 'src/pages/private/online-antrag/application-helper-function/AppHelperfunctions';
import { formStrucProjektdatenPruefassistentGlobal } from 'src/utils/formStruc';
import { checkReadOnlyInUeberarbeitung } from 'src/utils/helper';
import ApplicationHeading from '../../../../application-heading/ApplicationHeading';

// import schemas
import AntragSchema from 'src/lib/paths/antrag_FULL_Paths.json';
const P = AntragSchema.attributes;

const ProjektDatenAntragLogMob: FC<{ hasComment?: boolean }> = ({ hasComment }) => {
	const { application, setApplicationProperty, readOnly } = useApplication();

	const updatedReadOnly = checkReadOnlyInUeberarbeitung(application, readOnly, hasComment);

	const isVorhabensartFieldDisabled = useMemo(() => {
		if (readOnly) return true;
		if (get(application, P.Verbundpartner.path, []).length > 0) {
			return true;
		}
		return false;
	}, [application, readOnly]);

	return (
		<>
			<ApplicationHeading title='Projektdaten' description={PLATZHALTER_TEXT} />
			<PruefAssistenz
				statusPath={P.Allgemein_Pruefung_Pruefstatus.path}
				hinweisPath={P.Allgemein_Pruefung_Hinweis_Fuer_Den_Antragsteller.path}
				ueberarbeitetAmPath={P.Allgemein_Pruefung_Ueberarbeitet_Am.path}
				erledigtPath={P.Allgemein_Pruefung_Erledigt.path}
				formStruc={formStrucProjektdatenPruefassistentGlobal(application)}
			/>
			<Grid2 spacing={6} container>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte1(isVorhabensartFieldDisabled)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
				<Grid2 sm={6}>
					<CreateForm
						formStruc={formStrucSpalte2(application)}
						formValues={application}
						updateFormValuesFunc={setApplicationProperty}
						readOnly={updatedReadOnly}
					/>
				</Grid2>
			</Grid2>
		</>
	);
};

export default ProjektDatenAntragLogMob;

const formStrucSpalte1 = (isVorhabensartFieldDisabled?: boolean) => {
	let struc: FormStrucItem[] = [
		{
			fields: [
				P.Allgemein_Projekttitel,
				{
					...P.Allgemein_Vorhabensart,
					disabled: isVorhabensartFieldDisabled,
				},
			],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
	];
	return struc;
};
const formStrucSpalte2 = (application: any) => {
	let struc: FormStrucItem[] = [
		{
			fields: [{ ...P.Allgemein_Kurzwort, maxCharLength: 12 }],
			userProps: { direction: 'column', columnToDivide: 1 },
		},
		{
			fields: [
				{
					...P.Allgemein_Geplante_Projektlaufzeit_von,
					...getProjektLaufzeitVON_Validation(application),
				},
				{
					...P.Allgemein_Geplante_Projektlaufzeit_bis,
					...getProjektLaufzeitBIS_Validation(application),
				},
			],
		},
	];
	return struc;
};

export const getFormStrucProjektDatenAntragLogMob = (application: any) => {
	let result: FormStrucItem[] = [];
	result = concat(formStrucSpalte1(), formStrucSpalte2(application));

	if (checkIfPruefAssitenzNeedsToValidate(application, P.Allgemein_Pruefung_Pruefstatus.path, P.Allgemein_Pruefung_Erledigt.path)) {
		result = concat(formStrucProjektdatenPruefassistentGlobal(application), result);
	}
	return result;
};
